import { FC } from 'react';
import { Typography } from '@mui/material';
import { renderBodyWithLinks } from '../utils';
import type { LinkPreview } from '../types';

interface CommentBodyProps {
  body: string;
  linkPreviews: LinkPreview[];
}

/** Renders a comment body, turning URLs into links labeled with their page title. */
const CommentBody: FC<CommentBodyProps> = ({ body, linkPreviews }) => (
  <Typography
    variant="body2"
    component="div"
    sx={{
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      color: 'text.primary',
      lineHeight: 1.5,
    }}
  >
    {renderBodyWithLinks(body, linkPreviews)}
  </Typography>
);

export default CommentBody;
